import React, { Component } from "react";

import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import FileTree from "../../../components/Common/FileTree/index";
import CustomSelect from "../../../components/Common/CustomSelect";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { parseFormData } from "../../../helpers/utils";
import { addClient } from "../../../store/clients/actions";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

const optionStatus = [
  {
    options: [
      { label: "New", value: 1 },
      { label: "Signing contract", value: 2 },
      { label: "integration", value: 3 },
      { label: "Active", value: 4 },
      { label: "Deferred", value: -1 },
      { label: "On hold", value: -2 },
      { label: "Not active", value: -3 },
    ],
  },
];

const optionSource = [
  {
    options: [
      { label: "Unknown", value: 0 },
      { label: "Website", value: 1 },
      { label: "Linkedin", value: 2 },
      { label: "Email", value: 3 },
      { label: "Facebook messenger", value: 3 },
      { label: "Reference", value: 4 },
      { label: "Ad network", value: 5 },
      { label: "Up Sale", value: 6 },
      { label: "Friend", value: 7 },
    ],
  },
];

class AddClient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      docs: [],
      isFormSubmit: false,
    };
  }

  componentDidMount() { }

  formSubmit = (e, error, params) => {
    this.setState({ isFormSubmit: true });

    if (error.length === 0) {
      const data = parseFormData(params);
      this.props.addClient(data, this.state.docs, this.props.history);
    }
  };

  handleChangeDocs = data => {
    this.setState({ docs: data });
  };

  render() {

    const perms = ['is_admin', 'is_accountmanager', 'is_head_of_accountmanager'];
    const canEdit = Object.values(this.props.permissions).some(v => perms.includes(v))

    return (
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title="Add client| Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Clients"
              breadcrumbItem="Add client"
              link="/clients"
            />
            <Row>
              <Col lg="12">
                <AvForm className="needs-validation" onSubmit={this.formSubmit}>
                  <Card>
                    <CardBody>
                      <h4 className="card-title">General info</h4>
                      <Row>
                        <Col lg="6">
                          <div className="mb-3 select2-container">
                            <Label>Status</Label>
                            <CustomSelect
                              name="status"
                              options={optionStatus}
                              placeholder="Select status..."
                              classNamePrefix="select2-selection"
                              errorMessage="Status field is required"
                              // required
                              isFormSubmit={this.state.isFormSubmit}
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <FormGroup className="mb-3 ajax-select select2-container">
                            <Label>Source </Label>
                            <CustomSelect
                              name="source"
                              options={optionSource}
                              placeholder="Select source..."
                              classNamePrefix="select2-selection"
                              errorMessage="Source field is required"
                              // required
                              isFormSubmit={this.state.isFormSubmit}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6}>
                          <div className="mb-3 select2-container">
                            <label className="control-label">Legal Name</label>
                            <AvField
                              name="legal_name"
                              type="text"
                              errorMessage="Please provide a valid name."
                              className="form-control"
                              disabled={!canEdit}
                              validate={{ required: { value: true } }}
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <FormGroup className="mb-3 mt-3 mt-lg-0 templating-select select2-container">
                            <label className="control-label">Client Name</label>
                            <AvField
                              name="real_name"
                              disabled={!canEdit}
                              type="text"
                              errorMessage="Please provide a valid client name."
                              className="form-control"
                              validate={{ required: { value: true } }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6}>
                          <FormGroup className="mb-3 mt-3 mt-lg-0 templating-select select2-container">
                            <label className="control-label">Email</label>
                            <AvField
                              name="email"
                              type="email"
                              className="form-control"
                            />
                          </FormGroup>
                        </Col>
                        <Col lg={6}>
                          <FormGroup className="select2-container">
                            <Label>Client desc</Label>
                            <AvField
                              name="description"
                              type="text"
                              className="form-control"
                              validate={{ required: { value: false } }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6}>
                          <FormGroup className="mb-3 mt-3 mt-lg-0 templating-select select2-container">
                            <label className="control-label">Comment</label>
                            <AvField
                              name="comment"
                              type="text"
                              className="form-control"
                            // validate={{ required: { value: false } }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                  <Card>
                    <CardBody>
                      <Row>
                        <h4 className="card-title">Documents</h4>
                        <FileTree
                          onChange={this.handleChangeDocs}
                        // defaultValue={[]}
                        />
                      </Row>
                    </CardBody>
                  </Card>
                  <Card className="bg-transparent shadow-none">
                    <div className="text-end">
                      <button type="submit" className="btn btn-primary">
                        Save changes
                      </button>
                    </div>
                  </Card>
                </AvForm>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

AddClient.propTypes = {
  addClient: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  permissions: PropTypes.any,
};

const mapStateToProps = state => ({
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, { addClient })(AddClient);
